"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtifactInstanceStatuses = void 0;
const _ArtifactInstanceStatuses = [
    'initializing',
    'inProgress',
    'error',
    'success',
];
exports.ArtifactInstanceStatuses = _ArtifactInstanceStatuses;
//# sourceMappingURL=ArtifactInstance.js.map